import { get, post } from "./apiService";
import { ApiUrls } from "./ApiUrls";

export const getAlerts = async () => {
  try {
    const res = await get(ApiUrls.alerts.list);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const readAllAlerts = async () => {
  try {
    const res = await post(ApiUrls.alerts.readAll);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
